const profile = {
    name: "Md. Babul Hasan",
    nickname: "NoYoN",
    fullName: "MD. BABUL HASAN (NOYON)",
    designation: "Software Engineer",
    subDesignation: "( AI & Backend )",
    email: "bhyean@gmail.com",
    phone: "+880 1920599266",
    location: "Jhalokathi, Barishal, Bangladesh",
    github: "https://bhyeanhasan.github.io/",
    linkedin: "https://www.linkedin.com/in/bhyeanhasan/",
    blog: "https://bhyeanhasan.blogspot.com/",
    logo: "img/bh_logo.png",
    mainImage: "img/suit.png",
    profileImage: "https://iili.io/B2qc2j.jpg",
    aboutImage: "img/ppp.jpg",
    mission: "I am eager to leverage my academic background, technical skills, and passion to embark on a dynamic career path. Seeking a challenging role in software development or artificial intelligence where I can apply my knowledge and upgrade my skills.",
    interests: ["RC Projects", "Reading", "Gardening"],
    skills: [
        { category: "Domain Expertise", items: "Django Web, Django REST, React, ML, Deep Learning" },
        { category: "Programming Lang", items: "Python, C++, JavaScript, Java" },
        { category: "ML Framework / Package", items: "TensorFlow, Pytorch, Numpy, Pandas, Seaborn" },
        { category: "Internet of Things (IoT)", items: "Raspberry Pi, NodeMCU, Arduino" },
        { category: "Database", items: "MySQL, PostgreSQL, SQLite, SQL Server, Oracle, MongoDB" },
        { category: "Simulation Software", items: "MATLAB, PSPICE, R Studio" },
        { category: "Miscellaneous Tool", items: "Git (Version Control), Github, Azure, Docker, Latex" }
    ]
};

export default profile;
